<template>
  <div class="d-flex justify-center flex-nowrap ma-1 mb-2">
    <img v-for="(o,i) in stars.length" :key="i" class="stars" :src="require('@/assets/img/icons/'+stars.color+'_50x50.png')" />
    <template v-if="stars.length && stars.dot">
        <img class="stars" :src="require('@/assets/img/icons/dots_'+stars.color+'.png')" />
        <img class="stars" :src="require('@/assets/img/icons/'+stars.color+'_50x50.png')" />
    </template>
  </div>
</template>
<script>
export default {
  props: ['stars']
}
</script>
<style scoped>
.stars {
  width: 25px;
  margin-left: -10px;
}

</style>
